import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Ensures every SPA route change starts the user at the top of the new page.
// React Router preserves scroll position by default; this restores the
// conventional "top of page on navigate" behaviour expected across the site.
export const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // Skip when the URL includes a hash — that means the user asked for a
    // specific anchor within the page (e.g. /blog#featured) and we should
    // respect the browser's default behaviour instead.
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
